import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
    cardListContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '16px',
    },
    cardItem: {
        height: '100%',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
